import SmoothScroll from 'smooth-scroll'

export default ({}, inject) => {
  inject('smoothScroll', (selectors, options) => {
    const scroll = new SmoothScroll()
    const anchor = document.querySelector(selectors)
    if (options && Object.keys(options).length > 0) {
      scroll.animateScroll({
        anchor,
        ...options,
      })
    } else {
      scroll.animateScroll(anchor)
    }
  })
}
